import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import priceFormat from "../../../services/lib/price-format";

export default class LineTemplate extends PureComponent {
  static propTypes = {
    variant: PropTypes.string.isRequired,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    itemsMap: PropTypes.object,
    changeVariant: PropTypes.func,
    currentValue: PropTypes.string,
    dict: PropTypes.object,
    customHandleClick: PropTypes.func,
    description: PropTypes.bool,
    priceMap: PropTypes.object,
    filterOfItemsBy: PropTypes.object
  };
  render() {
    const {variant, title, subTitle, items, filterOfItemsBy} = this.props;
    return (
      <div className={`variant variant_${variant}`}>
        {title && <div className="variant__title">{title}</div>}
        {subTitle && <div className="variant__title">{subTitle}</div>}
        <div className="variant__content">
          {Array.isArray(items)
            ? this.getItemsFromArray(
                filterOfItemsBy
                  ? items.filter((item) => filterOfItemsBy.test(item))
                  : items
              )
            : this.getItemsFromObject(items)}
        </div>
      </div>
    );
  }
  getItemsFromArray(items) {
    return items.map((item) => {
      return this.getElement(item);
    });
  }
  getItemsFromObject(items) {
    const elements = [];
    for (const key in items) {
      if (items.hasOwnProperty(key)) {
        const item = items[key];
        elements.push(this.getElement(item, key));
      }
    }
    return elements;
  }
  getElement(value, key) {
    const {
      variant,
      changeVariant,
      customHandleClick,
      currentValue,
      dict,
      description,
      priceMap
    } = this.props;

    const val = key || value;
    return (
      <div
        key={val}
        className={`variant-option variant-option_${variant} variant__item${
          currentValue === val ? ` variant-option_active` : ``
        }`}
        onClick={(e) => {
          if (customHandleClick) {
            customHandleClick(e, variant, val);
          }
          changeVariant(e, variant, val);
        }}
      >
        <span
          className="variant-option__fill"
          title={dict[value]}
          style={{
            background: `${this.getBackground(val)} center center no-repeat`
          }}
        />
        {description && (
          <div className="variant-option__description">
            {dict[val]}
            {priceMap && priceMap[val] && (
              <span className="variant-option__price">
                <br />
                {`${priceFormat(priceMap[val][0])}/${priceFormat(
                  priceMap[val][1]
                )}`}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
  getBackground(val) {
    const {itemsMap, items, filterOfItemsBy} = this.props;
    if (itemsMap) {
      if (filterOfItemsBy && val.indexOf(`-`) > -1) {
        return itemsMap[val.replace(filterOfItemsBy, ``)];
      }
      return itemsMap[val];
    }
    return `url(${items[val]})`;
  }
}
